import * as param from './param';

export default {
  param,
};
